<template>
  <PageLayout title="命理·取名">
    <div class="naming-bazi-view">
      <el-tabs v-model="activeTab" type="border-card" class="main-tabs">
        <el-tab-pane label="八字命盘" name="bazi">
          <BaziPanel ref="baziPanelRef" />
        </el-tab-pane>
        <el-tab-pane label="八字合婚" name="heBazi">
          <HeBaziPanel />
        </el-tab-pane>
        <el-tab-pane label="取名分析" name="naming">
          <NamingPanel ref="namingPanelRef" />
        </el-tab-pane>
        <el-tab-pane label="命名匹配" name="match">
          <NamingMatchPanel
            :baziResult="baziData"
            :namingResult="namingData"
            :talentsResult="talentsData"
            :fullName="namingFullName"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </PageLayout>
</template>

<script setup>
import { ref, watch, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import PageLayout from '@/components/layout/PageLayout.vue'
import BaziPanel from '@/components/bazi/BaziPanel.vue'
import HeBaziPanel from '@/components/bazi/HeBaziPanel.vue'
import NamingPanel from '@/components/naming/NamingPanel.vue'
import NamingMatchPanel from '@/components/naming/NamingMatchPanel.vue'

const route = useRoute()
const router = useRouter()

// Template refs
const baziPanelRef = ref(null)
const namingPanelRef = ref(null)

// 根据 /bazi 或 /naming 路径判断默认 tab
const activeTab = ref('bazi')

onMounted(() => {
  if (route.path === '/naming') {
    activeTab.value = 'naming'
  } else {
    activeTab.value = 'bazi'
  }
})

// 切换 tab 时同步更新路由（命名匹配tab不换URL，保持当前路径）
watch(activeTab, (newTab) => {
  if (newTab === 'match' || newTab === 'heBazi') return // 命名匹配、八字合婚不换URL
  const pathMap = {
    'bazi': '/bazi',
    'naming': '/naming'
  }
  const targetPath = pathMap[newTab] || '/bazi'
  if (route.path !== targetPath) {
    router.replace(targetPath)
  }
})

// 路由变化时同步 tab（防止直接访问 URL 时 tab 不对）
watch(() => route.path, (newPath) => {
  if (newPath === '/naming' && activeTab.value !== 'naming') {
    activeTab.value = 'naming'
  } else if (newPath === '/bazi' && activeTab.value !== 'bazi') {
    activeTab.value = 'bazi'
  }
})

// 数据桥接：从子组件 expose 的数据传给 NamingMatchPanel
const baziData = computed(() => {
  return baziPanelRef.value?.baziResult || null
})

const namingData = computed(() => {
  return namingPanelRef.value?.namingResult || null
})

const talentsData = computed(() => {
  return namingPanelRef.value?.talentsResult || null
})

const namingFullName = computed(() => {
  return namingPanelRef.value?.fullName || ''
})
</script>

<style lang="scss" scoped>
.naming-bazi-view {
  .main-tabs {
    border: none;
    box-shadow: none;
    background: transparent;

    :deep(.el-tabs__header) {
      background: rgba(var(--color-accent-rgb), 0.05);
      border-bottom: 2px solid var(--color-accent);
      border-radius: var(--radius-lg) var(--radius-lg) 0 0;

      .el-tabs__item {
        font-size: 1.1rem;
        font-weight: 600;
        padding: 0 2rem;
        height: 50px;
        line-height: 50px;
        color: var(--color-text-secondary);
        transition: all 0.3s ease;

        &.is-active {
          color: var(--color-accent);
          background: rgba(var(--color-accent-rgb), 0.1);
        }

        &:hover {
          color: var(--color-accent);
        }
      }

      .el-tabs__nav-wrap {
        &::after {
          display: none;
        }
      }
    }

    :deep(.el-tabs__content) {
      padding: 0;
      border: none;
    }

    :deep(.el-tabs__body) {
      padding: 0;
    }
  }
}
</style>
